// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/iconProfile/iconProfile.js#1 $
'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tciconProfile
* @element ANY
* @description
* # tciconProfile
* Adds a Icon Profile to components, charts etc
*/
angular.module('tc.iconProfile', [])
.directive('tcIconProfile', function() {
	return {
		templateUrl: 'template/iconProfile/iconProfile.html',
		restrict: 'E',
		controller: 'IconProfileCtrl',
		scope: {
			tcIconProfile: '=',
			tcListRow: '=',
			tcListRowIndex: '=',
			id: '@',
			tcIconUrlHandler: '&tcIconUrlHandler',
			tcSelectMessageFunc: '=tcListRowSelectMessage',
		},
	};
});
